import { render, staticRenderFns } from "./create-bill.vue?vue&type=template&id=b64fbab2&"
import script from "./create-bill.vue?vue&type=script&lang=js&"
export * from "./create-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports